module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/billing-control/bc-account-client/bc-juridical-proposal/bc-j-attachment/bc-j-attachment.component.scss
// module id = ./src/app/billing-control/bc-account-client/bc-juridical-proposal/bc-j-attachment/bc-j-attachment.component.scss
// module chunks = main